module.exports = __webpack_public_path__ + "img/黄浦区南京街道敬老院1.ef271cb1.jpeg";